import { BorderGridContainer, GridBox, TypeWrapper } from '@ahmdigital/ui';
import { useSelector } from 'react-redux';

import { useByocNavigationContext } from './context/byoc-navigation-context';
import Footer from './components/footer';
import getStepComponent from './step-components';
import Head from '../../../utils/head';
import OfferBanner from '../../components/offers/banner';
import selectTargetSegment from '../../selectors/select-target-segment';
import StepHeaderNavigation from './components/step-header-navigation';
import useSyncCustomerProductType from './hooks/use-sync-customer-product-type';

const title = 'Choose Your Own Hospital & Extras Cover';
const description =
  'Compare ahm’s hospital and extras cover. Select from inclusions, browse products and build a health insurance plan that best suits your needs. Join today.';

const BuildYourCover = () => {
  const { activeSlug, productTypeForOffers } = useByocNavigationContext();
  const targetSegment = useSelector(selectTargetSegment);
  useSyncCustomerProductType();

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <BorderGridContainer hideBorderTop>
        <GridBox padding="0 0 1rem 0">
          <OfferBanner filterProductType={productTypeForOffers ?? 'combined'} targetSegment={targetSegment} />
          <TypeWrapper variant="marginBottomSpacer6">
            <StepHeaderNavigation />
            {getStepComponent(activeSlug)}
          </TypeWrapper>
        </GridBox>
        <Footer />
      </BorderGridContainer>
    </>
  );
};

export default BuildYourCover;
